import { Box, Group, Stack } from '@mantine/core';
import { RedactionMatchPreviewContentProps } from './types';
import { matchBox, matchHighlight, pageIndex } from './styles.css';
import { palette } from '@app/shared/ui-kit/colors';
import { useTranslation } from 'react-i18next';

export default function RedactionMatchPreviewContent({
  match,
  resource,
  showPageIndex = false,
  ...stackProps
}: RedactionMatchPreviewContentProps) {
  const { t } = useTranslation();

  if (!match.rangeInPreview || !match.previewText) {
    return null;
  }

  const [start, length] = match.rangeInPreview;

  const text = {
    before: match.previewText.slice(0, start),
    match: match.previewText.slice(start, start + length),
    after: match.previewText.slice(start + length),
  };

  return (
    <Stack className={matchBox} gap={5} {...stackProps}>
      <Box fz={12} c={palette.blackroomDarkGray1}>
        {text.before}
        <span className={matchHighlight}>{text.match}</span>
        {text.after}
      </Box>
      {typeof match.pageIndex === 'number' && showPageIndex && (
        <Group c="blackroomBlack" fz={10} justify="end">
          <Box className={pageIndex}>
            {`${t('Redaction:RedactionMatchTag.page')} ${match.pageIndex}`}
          </Box>
        </Group>
      )}
    </Stack>
  );
}
